export default __webpack_public_path__ + "static/media/link.ee404cfa.svg";